import { useState, useEffect } from 'react';

/**
 * Custom hook to manage welcome tour state
 * 
 * Checks if tour should be shown:
 * - After registration (first time user)
 * - Can be manually reopened via ? icon
 */
export const useWelcomeTour = (isAuthenticated) => {
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [hasSeenTour, setHasSeenTour] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      // Check if user has completed the tour
      const tourCompleted = localStorage.getItem('welcome-tour-completed');
      const hasShownTour = sessionStorage.getItem('welcome-tour-shown');
      
      setHasSeenTour(!!tourCompleted);

      // Show tour automatically if:
      // 1. User is authenticated
      // 2. Tour hasn't been completed
      // 3. Tour hasn't been shown in this session (to avoid showing on every page load)
      if (!tourCompleted && !hasShownTour && !hasSeenTour) {
        // Small delay to ensure page is loaded
        const timer = setTimeout(() => {
          setIsTourOpen(true);
          sessionStorage.setItem('welcome-tour-shown', 'true');
        }, 800); // Slightly longer delay to ensure dashboard is rendered
        return () => clearTimeout(timer);
      }
    }
  }, [isAuthenticated, hasSeenTour]);

  const openTour = () => {
    setIsTourOpen(true);
  };

  const closeTour = () => {
    setIsTourOpen(false);
  };

  const completeTour = () => {
    localStorage.setItem('welcome-tour-completed', 'true');
    setHasSeenTour(true);
    setIsTourOpen(false);
  };

  return {
    isTourOpen,
    openTour,
    closeTour,
    completeTour,
    hasSeenTour
  };
};
